/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import { addMetaToMutation } from '../../mutators/add-meta';
import type {
  CreateFtpAccountRequest,
  CreateFtpAccountResponse,
  DeleteFtpAccountRequest,
  DeleteFtpAccountResponse,
  Error,
  ListFtpAccountsResponse,
  ListSiteFtpAccountsParams,
  ModifySiteFtpAccountParams,
  SiteID,
  UpdateFtpAccountRequest,
  UpdateFtpAccountResponse,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns paginated FTP accounts for the site, including username, home directory, disk quota, and disk usage. Optionally filter by partial username match.
 * @summary List FTP accounts
 */
export const listSiteFtpAccounts = (
  id: SiteID,
  params?: ListSiteFtpAccountsParams,
  signal?: AbortSignal
) => {
  return customFetch<ListFtpAccountsResponse>({
    url: `/v1/sites/${id}/ftp/accounts`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteFtpAccountsQueryKey = (id?: SiteID, params?: ListSiteFtpAccountsParams) => {
  return [`/v1/sites/${id}/ftp/accounts`, ...(params ? [params] : [])] as const;
};

export const getListSiteFtpAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteFtpAccounts>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFtpAccountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFtpAccounts>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteFtpAccountsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteFtpAccounts>>> = ({ signal }) =>
    listSiteFtpAccounts(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/ftp/accounts`,
      operationId: 'app.controllers.ftp_accounts_controller.list_site_ftp_accounts',
      operationName: 'listSiteFtpAccounts',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteFtpAccounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteFtpAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteFtpAccounts>>
>;
export type ListSiteFtpAccountsQueryError = Error;

export function useListSiteFtpAccounts<
  TData = Awaited<ReturnType<typeof listSiteFtpAccounts>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteFtpAccountsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFtpAccounts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteFtpAccounts>>,
          TError,
          Awaited<ReturnType<typeof listSiteFtpAccounts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFtpAccounts<
  TData = Awaited<ReturnType<typeof listSiteFtpAccounts>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFtpAccountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFtpAccounts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteFtpAccounts>>,
          TError,
          Awaited<ReturnType<typeof listSiteFtpAccounts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFtpAccounts<
  TData = Awaited<ReturnType<typeof listSiteFtpAccounts>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFtpAccountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFtpAccounts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List FTP accounts
 */

export function useListSiteFtpAccounts<
  TData = Awaited<ReturnType<typeof listSiteFtpAccounts>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFtpAccountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFtpAccounts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteFtpAccountsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteFtpAccountsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteFtpAccounts>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFtpAccountsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFtpAccounts>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteFtpAccountsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteFtpAccounts>>> = ({ signal }) =>
    listSiteFtpAccounts(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/ftp/accounts`,
      operationId: 'app.controllers.ftp_accounts_controller.list_site_ftp_accounts',
      operationName: 'listSiteFtpAccounts',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteFtpAccounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteFtpAccountsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteFtpAccounts>>
>;
export type ListSiteFtpAccountsSuspenseQueryError = Error;

export function useListSiteFtpAccountsSuspense<
  TData = Awaited<ReturnType<typeof listSiteFtpAccounts>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteFtpAccountsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFtpAccounts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFtpAccountsSuspense<
  TData = Awaited<ReturnType<typeof listSiteFtpAccounts>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFtpAccountsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFtpAccounts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFtpAccountsSuspense<
  TData = Awaited<ReturnType<typeof listSiteFtpAccounts>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFtpAccountsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFtpAccounts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List FTP accounts
 */

export function useListSiteFtpAccountsSuspense<
  TData = Awaited<ReturnType<typeof listSiteFtpAccounts>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteFtpAccountsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFtpAccounts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteFtpAccountsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new FTP login for the site. Provide username, password, home directory, and optional disk quota in MB. Password must meet strength requirements.
 * @summary Create an FTP account
 */
export const createSiteFtpAccount = (
  id: SiteID,
  createFtpAccountRequest: CreateFtpAccountRequest,
  signal?: AbortSignal
) => {
  return customFetch<CreateFtpAccountResponse>({
    url: `/v1/sites/${id}/ftp/accounts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createFtpAccountRequest,
    signal,
  });
};

export const getCreateSiteFtpAccountMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteFtpAccount>>,
    TError,
    { id: SiteID; data: CreateFtpAccountRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteFtpAccount>>,
  TError,
  { id: SiteID; data: CreateFtpAccountRequest },
  TContext
> => {
  const mutationKey = ['createSiteFtpAccount'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteFtpAccount>>,
    { id: SiteID; data: CreateFtpAccountRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSiteFtpAccount(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/ftp/accounts` },
    {
      operationId: 'app.controllers.ftp_accounts_controller.create_site_ftp_account',
      operationName: 'createSiteFtpAccount',
    }
  );

  return customOptions;
};

export type CreateSiteFtpAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSiteFtpAccount>>
>;
export type CreateSiteFtpAccountMutationBody = CreateFtpAccountRequest;
export type CreateSiteFtpAccountMutationError = Error;

/**
 * @summary Create an FTP account
 */
export const useCreateSiteFtpAccount = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteFtpAccount>>,
      TError,
      { id: SiteID; data: CreateFtpAccountRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteFtpAccount>>,
  TError,
  { id: SiteID; data: CreateFtpAccountRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteFtpAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates an existing FTP account identified by the username query parameter. Change password, home directory, and/or disk quota independently.
 * @summary Update an FTP account
 */
export const modifySiteFtpAccount = (
  id: SiteID,
  updateFtpAccountRequest: UpdateFtpAccountRequest,
  params: ModifySiteFtpAccountParams
) => {
  return customFetch<UpdateFtpAccountResponse>({
    url: `/v1/sites/${id}/ftp/accounts`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateFtpAccountRequest,
    params,
  });
};

export const getModifySiteFtpAccountMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modifySiteFtpAccount>>,
    TError,
    { id: SiteID; data: UpdateFtpAccountRequest; params: ModifySiteFtpAccountParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modifySiteFtpAccount>>,
  TError,
  { id: SiteID; data: UpdateFtpAccountRequest; params: ModifySiteFtpAccountParams },
  TContext
> => {
  const mutationKey = ['modifySiteFtpAccount'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modifySiteFtpAccount>>,
    { id: SiteID; data: UpdateFtpAccountRequest; params: ModifySiteFtpAccountParams }
  > = props => {
    const { id, data, params } = props ?? {};

    return modifySiteFtpAccount(id, data, params);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/ftp/accounts` },
    {
      operationId: 'app.controllers.ftp_accounts_controller.modify_site_ftp_account',
      operationName: 'modifySiteFtpAccount',
    }
  );

  return customOptions;
};

export type ModifySiteFtpAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof modifySiteFtpAccount>>
>;
export type ModifySiteFtpAccountMutationBody = UpdateFtpAccountRequest;
export type ModifySiteFtpAccountMutationError = Error;

/**
 * @summary Update an FTP account
 */
export const useModifySiteFtpAccount = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof modifySiteFtpAccount>>,
      TError,
      { id: SiteID; data: UpdateFtpAccountRequest; params: ModifySiteFtpAccountParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof modifySiteFtpAccount>>,
  TError,
  { id: SiteID; data: UpdateFtpAccountRequest; params: ModifySiteFtpAccountParams },
  TContext
> => {
  const mutationOptions = getModifySiteFtpAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Permanently removes the FTP account identified by username in the request body. The login credentials will no longer work for file transfers.
 * @summary Delete an FTP account
 */
export const deleteSiteFtpAccount = (
  id: SiteID,
  deleteFtpAccountRequest: DeleteFtpAccountRequest
) => {
  return customFetch<DeleteFtpAccountResponse>({
    url: `/v1/sites/${id}/ftp/accounts`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteFtpAccountRequest,
  });
};

export const getDeleteSiteFtpAccountMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSiteFtpAccount>>,
    TError,
    { id: SiteID; data: DeleteFtpAccountRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSiteFtpAccount>>,
  TError,
  { id: SiteID; data: DeleteFtpAccountRequest },
  TContext
> => {
  const mutationKey = ['deleteSiteFtpAccount'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSiteFtpAccount>>,
    { id: SiteID; data: DeleteFtpAccountRequest }
  > = props => {
    const { id, data } = props ?? {};

    return deleteSiteFtpAccount(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/ftp/accounts` },
    {
      operationId: 'app.controllers.ftp_accounts_controller.delete_site_ftp_account',
      operationName: 'deleteSiteFtpAccount',
    }
  );

  return customOptions;
};

export type DeleteSiteFtpAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSiteFtpAccount>>
>;
export type DeleteSiteFtpAccountMutationBody = DeleteFtpAccountRequest;
export type DeleteSiteFtpAccountMutationError = Error;

/**
 * @summary Delete an FTP account
 */
export const useDeleteSiteFtpAccount = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSiteFtpAccount>>,
      TError,
      { id: SiteID; data: DeleteFtpAccountRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSiteFtpAccount>>,
  TError,
  { id: SiteID; data: DeleteFtpAccountRequest },
  TContext
> => {
  const mutationOptions = getDeleteSiteFtpAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
